"use strict";

var _classCallCheck = require("/builds/web/profcadres/esm/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/builds/web/profcadres/esm/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/builds/web/profcadres/esm/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/builds/web/profcadres/esm/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/builds/web/profcadres/esm/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/builds/web/profcadres/esm/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var util_1 = __importDefault(require("util"));

function indent(str) {
  return str.split('\n').map(function (s) {
    return s ? "  ".concat(s) : '';
  }).join('\n');
}

function json(data) {
  return JSON.stringify(data, null, 2);
}

var AxiosError = /*#__PURE__*/function (_Error, _util_1$default$inspe) {
  _inherits(AxiosError, _Error);

  var _super = _createSuper(AxiosError);

  function AxiosError(messageOrError, error) {
    var _this;

    _classCallCheck(this, AxiosError);

    var err;

    if (typeof messageOrError === 'string') {
      _this = _super.call(this, messageOrError);
      err = error;
    } else {
      _this = _super.call(this, messageOrError.message);
      err = messageOrError;
    }

    var _err = err,
        config = _err.config,
        request = _err.request,
        response = _err.response;
    _this.config = config;
    _this.request = request;
    _this.response = response;

    if (response && response.status) {
      _this.status = response.status;
    }

    _this.name = 'AxiosError';
    return _possibleConstructorReturn(_this);
  }

  _createClass(AxiosError, [{
    key: _util_1$default$inspe,
    value: function value() {
      var requestMessage = '';

      if (this.config) {
        var data = this.config.data;

        try {
          data = JSON.parse(data);
        } catch (_) {} // eslint-disable-line


        var requestData = '';

        if (this.config.data) {
          requestData = "\nRequest Data -\n".concat(indent(json(data)));
        }

        requestMessage = "\nRequest -\n  ".concat(this.config.method ? this.config.method.toUpperCase() : '', " ").concat(this.config.url, "\n").concat(requestData);
      }

      var responseMessage = '';

      if (this.response) {
        var responseData;

        if (this.response.data) {
          responseData = "\nResponse Data -\n".concat(indent(json(this.response.data)));
        }

        responseMessage = "\nResponse -\n  ".concat(this.response.status, " ").concat(this.response.statusText, "\n").concat(responseData);
      }

      return "\n".concat(this.stack, "\n\nError Message -\n  ").concat(this.message, "\n").concat(requestMessage, "\n").concat(responseMessage, "\n");
    }
  }]);

  return AxiosError;
}( /*#__PURE__*/_wrapNativeSuper(Error), util_1.default.inspect.custom);

module.exports = AxiosError;